import { Reveal } from "./Reveal";
import { IMAGES, SERVICES } from "../data/content";

export const Services = () => (
  <section id="sherbimet" data-testid="services-section" className="bg-ink py-24 texture-grain sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <p className="eyebrow mb-5">Çfarë realizojmë</p>
            <h2 data-testid="services-title" className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
              Shërbimet tona
            </h2>
            <p data-testid="services-intro" className="mt-6 max-w-md text-base leading-relaxed text-white/60 sm:text-lg">
              Realizojmë punime metalike sipas kërkesave, dimensioneve dhe ideve të klientëve.
            </p>
          </Reveal>
          <Reveal delay={0.2} className="mt-10 hidden lg:block">
            <div className="overflow-hidden">
              <img
                src={IMAGES.pergola}
                alt="Pergolë metalike e realizuar nga ALBESI AXH METAL"
                data-testid="services-image"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
            <p className="mt-3 text-xs uppercase tracking-[0.25em] text-white/35">Pergolë metalike · Projekt i realizuar</p>
          </Reveal>
        </div>

        <div>
          {SERVICES.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 0.05, 0.3)}>
              <div
                data-testid={`service-item-${i}`}
                className="group flex items-baseline gap-6 border-b hairline py-6 transition-colors duration-300 first:border-t hover:border-bronze/40 sm:gap-10 sm:py-7"
              >
                <span className="font-display text-sm font-semibold text-bronze/80">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-display text-lg font-semibold text-white transition-colors duration-300 group-hover:text-bronze sm:text-xl">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-white/45">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
